import styled from 'styled-components';
import { fontSizes, fontWeights } from '../../../defaultTheme';
const IconButtonBase = styled.button `
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: ${({ isStacked }) => (isStacked ? 'column' : 'row')};
  position: relative;
  font-family: Open Sans;
  height: 48px;
  width: ${({ isStacked }) => (isStacked ? '60px' : 'auto')};
  color: ${({ theme }) => theme.button.background};
  background: transparent;
  border: none;
  font-size: ${({ isStacked }) => isStacked ? `${fontSizes.small}px` : `${fontSizes.root}px`};
  font-weight: ${fontWeights.regular};
  cursor: pointer;

  .activeIcon {
    display: none;
  }

  &:hover,
  &:focus {
    font-weight: ${fontWeights.bold};
    .restIcon {
      display: none;
    }
    .activeIcon {
      display: flex;
    }
  }

  &:hover {
    text-decoration: underline;
  }
`;
export default IconButtonBase;
//# sourceMappingURL=subcomponents.js.map